import { useEffect, useRef, useState } from "react"
import { useHistory } from "react-router"
import ReactPlayer from "react-player"
import styled from "styled-components"
import { io } from "socket.io-client"
import mapboxgl from "mapbox-gl/dist/mapbox-gl-csp"
import MapboxWorker from "worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker"
import "mapbox-gl/dist/mapbox-gl.css"

import { useGesture } from "react-use-gesture"
import { useMeasure } from "react-use"

import categories from "./data"
import postmarkIcon from "./images/postmark.png"
import BackIcon from "./images/back_icon.svg"
import MapIcon from "./images/map1_icon.svg"
import TrainIcon from "./images/train_icon.svg"
import TimeIcon from "./images/time_icon.svg"
import ClockSidebar from "./Location.clock"
import { useStore } from "../../state/store"

import MapVideoFile from "./map.mp4"

import "./Location.css"

mapboxgl.workerClass = MapboxWorker
const url = process.env.REACT_APP_MARKETING_SUITE
const role = process.env.REACT_APP_ROLE

export default function Location() {
  const history = useHistory()

  const socket = useRef()
  const map = useRef()
  const markers = useRef([])

  const openSidebar = useStore(state => state.openSidebar)
  const setOpenSidebar = useStore(state => state.setOpenSidebar)

  const mapCategory = useStore(state => state.mapCategory)
  const setMapCategory = useStore(state => state.setMapCategory)

  const mapLocation = useStore(state => state.mapLocation)
  const setMapLocation = useStore(state => state.setMapLocation)

  const openMapVideo = useStore(state => state.openMapVideo)
  const setOpenMapVideo = useStore(state => state.setOpenMapVideo)

  const setOpenClockSidebar = useStore(state => state.setOpenClockSidebar)

  const sidebarScrollPos = useStore(state => state.sidebarScrollPos)
  const setSidebarScrollPos = useStore(state => state.setSidebarScrollPos)

  const [activeCategory, setActiveCategory] = useState(null)
  // eslint-disable-next-line
  const [activeLocation, setActiveLocation] = useState(null)

  const [playVideo, setPlayVideo] = useState(false)

  const [locationRef, locationMeasure] = useMeasure()

  console.log(locationMeasure)

  const sidebarContentRef = useRef()

  const handleCategoryClick = category => {
    if (category.name === mapCategory) {
      //inactive
      setMapCategory(null)
      setOpenSidebar(false)
    } else {
      //active
      setMapCategory(category.name)
      setOpenSidebar(true)
    }
  }

  const setMarkers = (categoryItem, locationItem) => {
    /**
     * Remove all markers and then add the ones that match the current state.
     */

    for (let marker of markers.current) {
      marker.remove()
    }
    markers.current = []
    if (categoryItem) {
      for (let location of categoryItem.locations) {
        const div = document.createElement("div")
        const img = document.createElement("img")

        if (locationItem && location.name === locationItem.name) {
          const markerMid = document.createElement("div")
          markerMid.classList.add("marker-mid")

          // Can't use react components as it expects a DOM element.
          div.classList.add("marker-large")
          const markerTop = document.createElement("div")
          markerTop.classList.add("marker-top")
          const markerBottom = document.createElement("div")
          markerBottom.classList.add("marker-bottom")
          const topLeft = document.createElement("div")
          topLeft.classList.add("top-left")
          const topRight = document.createElement("div")
          topRight.classList.add("top-right")
          const bottomLeft = document.createElement("bottom-left")
          bottomLeft.classList.add("marker")
          const bottomRight = document.createElement("bottom-right")
          bottomRight.classList.add("bottom-right")

          const lineSpan = document.createElement("div")

          const topSpan = document.createElement("span")
          const middleSpan = document.createElement("span")
          const bottomSpan = document.createElement("span")
          div.appendChild(img)
          div.appendChild(markerTop)
          div.appendChild(markerMid)
          div.appendChild(markerBottom)
          markerTop.appendChild(topLeft)
          markerTop.appendChild(topRight)
          markerTop.appendChild(topSpan)

          markerMid.appendChild(lineSpan)

          markerBottom.appendChild(bottomLeft)
          markerBottom.appendChild(bottomRight)
          markerBottom.appendChild(middleSpan)
          markerBottom.appendChild(bottomSpan)
          img.src = categoryItem.largeIcon
          topSpan.innerText = locationItem.name
          const fontSize =
            locationItem?.name?.length > 30 ? 15 : locationItem?.name?.length < 12 ? 22 : 20
          topSpan.style.fontSize = `${fontSize}px`

          lineSpan.style.fontSize = "12.5px"
          lineSpan.style.display = "flex"

          locationItem.lin && console.log("locationItem", locationItem)
          if (locationItem.line) {
            lineSpan.innerHTML = locationItem.line
              .map(
                (l, i) =>
                  `<div style="
                  flex: 1; 
                  // border: red solid 2px;
                  background-image: url(${process.env.PUBLIC_URL}/assets/images/trainicons/${locationItem.line[i]}.jpg); 
                  background-size: cover;
                  justify-content: center; 
                  align-itmes: center; 
                  margin: 2px;
                  height: 26px; 
                  width: 26px"></div>`
              )
              .join("")
          }

          //middleSpan.innerText = "Minutes from Coronation Sq"
          bottomSpan.innerHTML = `${locationItem.distances[0] < 10 ? "&nbsp;" : ""}${
            locationItem.distances[0]
          }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
          bottomSpan.innerHTML += `${locationItem.distances[1] < 10 ? "&nbsp;" : ""}${
            locationItem.distances[1]
          }&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
          bottomSpan.innerHTML += `${locationItem.distances[2] < 10 ? "&nbsp;" : ""}${
            locationItem.distances[2]
          }`
        } else {
          img.style.width = "40px"
          img.src = categoryItem.smallIcon
          div.appendChild(img)
        }
        div.style.cursor = "pointer"
        div.dataset.name = location.name
        div.addEventListener("click", () => {
          setMapLocation(location.name)
        })
        markers.current.push(
          new mapboxgl.Marker(div, { anchor: "bottom" })
            .setLngLat([...location.coordinates])
            .addTo(map.current)
        )
      }
    }
  }

  const handleWheel = state => {
    if (sidebarContentRef) {
      setSidebarScrollPos(sidebarContentRef.current.scrollTop)
    }
  }

  const bind = useGesture({
    onDrag: state => handleWheel(state),
    onWheel: state => handleWheel(state)
  })

  useEffect(() => {
    mapboxgl.accessToken =
      "pk.eyJ1Ijoidm1pc3R1ZGlvIiwiYSI6ImNrc2lzcDFtYzBkMXMydm5jNGxxOXRncnEifQ.UxpGoxNNSkeTVIhflMc1zA"

    const center = [-0.1129, 51.5233]

    const bounds = [
      [-1.2983, 51.0344],
      [0.7722, 52.082]
    ]

    map.current = new mapboxgl.Map({
      container: "map",
      style: "mapbox://styles/vmistudio/ckt8ketl2293m18mpdurt60du",
      center: center,
      zoom: 14,
      maxBounds: bounds,
      attributionControl: false
    })

    map.current.on("click", e => {
      /**
       * User has clicked somewhere on the map - disable any active markers.
       */

      if (e.originalEvent.target.tagName !== "IMG") {
        setMapLocation(null)
      }
      if (e.originalEvent.target.id === "square") {
        history.push("/finder")
      }
    })

    map.current.on("zoom", e => {
      const zoom = map.current.getZoom()
      const el = document.querySelector("#square")
      if (zoom < 14) {
        const zoomDiff = parseInt((14 - zoom) * 20)
        el.style.width = `${120 - zoomDiff}px`
      } else {
        el.style.width = `${120}px`
      }
    })

    if (role) {
      socket.current = io(url)
      if (role === "sender") {
        map.current.on("move", e => {
          socket.current.emit("map", {
            ...e.target.getCenter(),
            zoom: e.target.getZoom()
          })
        })
      }
      if (role === "recipient") {
        socket.current.on("map", data => {
          map.current.flyTo({
            center: [data.lng, data.lat],
            zoom: [data.zoom]
          })
        })
      }
    }

    const img = document.createElement("img")
    img.style.width = "120px"
    img.style.zIndex = "1"
    img.src = postmarkIcon
    img.id = "square"

    new mapboxgl.Marker(img).setLngLat(center).addTo(map.current)
  }, [])

  useEffect(() => {
    const categoryItem = categories.filter(c => c.name === mapCategory)?.[0]
    setActiveCategory(categoryItem)

    const locationItem = categoryItem?.locations.filter(l => l.name === mapLocation)?.[0]
    setActiveLocation(locationItem)

    setMarkers(categoryItem, locationItem)
  }, [mapCategory, mapLocation])

  useEffect(() => {
    if (role === "recipient") {
      if (sidebarContentRef.current) {
        sidebarContentRef.current.scrollTop = sidebarScrollPos
      }
    }
  }, [sidebarScrollPos])

  return (
    <div className="location" ref={locationRef}>
      <div id="map" />
      {openMapVideo && (
        <MapVideo>
          <MapControls>
            <IconButton
              icon={TimeIcon}
              onClick={() => {
                setOpenClockSidebar(true)
              }}
            />
            <IconButton
              icon={MapIcon}
              onClick={() => {
                setOpenMapVideo(false)
                setOpenSidebar(false)
                setPlayVideo(false)
              }}
            />
          </MapControls>
          <ClockSidebar />
          <ReactPlayer
            url={MapVideoFile}
            width="100%"
            height="100%"
            playsinline={true}
            loop={true}
            playing={playVideo}
            controls={false}
            muted={true}
          />
        </MapVideo>
      )}
      <Sidebar open={openSidebar}>
        <SidebarCloseButton onClick={() => setOpenSidebar(false)} />
        {activeCategory && (
          <SidebarContent {...bind()} ref={sidebarContentRef}>
            <SidebarHeader color={activeCategory.color}>
              <SidebarTitle src={activeCategory.title} />
              <SidebarSubTitle>{activeCategory.subTitle}</SidebarSubTitle>
              <SidebarDescription>{activeCategory.description}</SidebarDescription>
            </SidebarHeader>
            <SidbarBody>
              <SidebarListTitle>Highlights</SidebarListTitle>
              <SidebarList>
                {activeCategory.locations.map((location, index) => (
                  <SidebarItem
                    key={index}
                    index={index + 1}
                    name={location.name}
                    onClick={() => {
                      setMapCategory(activeCategory.name)
                      setMapLocation(location.name)
                    }}
                  />
                ))}
              </SidebarList>
            </SidbarBody>
          </SidebarContent>
        )}
      </Sidebar>
      <Categories open={!openMapVideo}>
        {categories.map(category => (
          <CatItem
            key={category.name}
            image={category.icon}
            active={mapCategory === category.name}
            activeImage={category.activeIcon}
            onClick={() => handleCategoryClick(category)}
          />
        ))}
        <Gap />
        <IconButton
          icon={TrainIcon}
          onClick={() => {
            setPlayVideo(true)
            setOpenMapVideo(!openMapVideo)
            setOpenSidebar(false)
            setMapCategory(null)
            setMapLocation(null)
          }}
        />
      </Categories>
    </div>
  )
}

const MapVideo = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
`

const MapControls = styled.div`
  position: fixed;
  bottom: 1em;
  left: 1em;
  z-index: 2;
  display: flex;
  gap: 1em;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Gap = styled.div`
  height: 5vh;
`

const IconButton = styled.button`
  width: 3em;
  height: 3em;
  outline: none;
  border: none;
  cursor: pointer;
  border-radius: 2em;
  transition: all 0.35s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  background-image: ${({ icon }) => `url(${icon})`};
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #00000000;
  &:hover {
    background-color: #efefef;
  }
`

const Categories = styled.div`
  position: fixed;
  top: 0;
  left: ${({ open }) => (open ? "0" : "-7em")};
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 7em;
  height: 100%;
  background: #183045;
  transition: left 0.5s ease-in-out;
`
const CatItem = styled.div`
  width: 5em;
  height: 3.5em;
  margin: 0.5em 0;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  position: relative;
  background-image: ${({ active, image, activeImage }) => `url(${active ? activeImage : image})`};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  &:hover {
    opacity: 0.8;
  }
`
const Sidebar = styled.div`
  position: fixed;
  top: 0;
  left: ${({ open }) => (open ? "7em" : "-30em")};
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 25em;
  height: 100%;
  background: #ffffff;
  transition: left 0.5s ease-in-out;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
`
const SidebarCloseButton = styled.button`
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  z-index: 1;
  width: 2.5em;
  height: 2.5em;
  outline: none;
  border: none;
  cursor: pointer;
  border-radius: 2em;
  transition: all 0.35s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  background-image: url(${BackIcon});
  background-size: 50% 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #00000000;
  &:hover {
    background-color: #efefef;
  }
`
const SidebarContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
`
const SidebarHeader = styled.div`
  padding: 1.5em;
  background-color: ${props => props.color};
`
const SidebarTitle = styled.img`
  width: 100%;
`
const SidebarSubTitle = styled.p`
  font-family: NewParisKingSize-Regular;
  font-weight: 400;
  font-size: 1.3em;
  line-height: 140%;
  color: #ffffff;
  margin: 1em 0;
  padding: 0;
  /* text-align: justify; */
`

const SidebarDescription = styled.p`
  font-family: AzoSans-Regular;
  font-weight: 400;
  font-size: 1em;
  line-height: 120%;
  color: #ffffff;
  margin: 1em 0;
  padding: 0;
  text-align: justify;
`
const SidbarBody = styled.div`
  padding: 1.5em;
  background-color: white;
`

const SidebarListTitle = styled.p`
  font-family: OuterSans-Regular;
  font-weight: 400;
  font-size: 2em;
  line-height: 140%;
  color: #3d4e4c;
  margin: 0;
  padding: 0;
  margin-bottom: 0.5em;
`

const SidebarList = styled.div`
  border-bottom: 1px solid #874544;
  border-top: 1px solid #874544;
`

const ItemHolder = styled.div`
  border-bottom: 1px solid #874544;
  border-top: 1px solid #874544;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1em 0;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`
const ItemId = styled.div`
  width: 2.5em;
  height: 2.5em;
  min-width: 2.5em;
  min-height: 2.5em;
  border-radius: 3em;
  border: 2px solid #7b918e;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: OuterSans-Regular;
  font-size: 1.2em;
  line-height: 110%;
  color: #7b918e;
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    height: 90%;
    border-radius: 3em;
    border: 0.5px solid #7b918e;
  }
`
const ItemName = styled.p`
  font-family: AzoSans-Regular;
  font-size: 1em;
  line-height: 110%;
  color: #3d4e4c;
  margin: 0;
  padding: 0;
  padding-left: 1.5em;
`

const SidebarItem = ({ index, name, onClick }) => {
  return (
    <ItemHolder onClick={onClick}>
      <ItemId>{index}</ItemId>
      <ItemName>{name}</ItemName>
    </ItemHolder>
  )
}
